/**
 * Matches @import rules in CSS
 * @link https://developer.mozilla.org/en-US/docs/Web/CSS/@import
 */
const IMPORT_STATEMENT_REGEX = /(@import\surl\((["']?)(.*?)\2\));?/gi;

/**
 * Finds all @import statements in a css file using Regex
 * @param css the stylesheet to look through
 * @returns an array of all the import statements
 */
function FindImportStatements(css: string): string[] {
  const importStatements: string[] = [];
  for (const match of css.matchAll(IMPORT_STATEMENT_REGEX)) {
    importStatements.push(match[1]);
  }
  return importStatements;
}
/**
 * Wraps a stylesheet in a CSS Cascade Layer
 * Moves @import rules above the layer and imports them into the layer
 * @param css the stylesheet to wrap in a layer, if layer is null then will not wrap
 * @param layer the layer to put the styles in
 * @param removeImportant whether to strip !important attributes or not
 * @returns the css stylesheet wrapped in a layer
 * @link https://developer.mozilla.org/en-US/docs/Learn/CSS/Building_blocks/Cascade_layers
 */
export function WrapCSSInLayer(
  css: string,
  layer?: string,
  removeImportant = false
): string {
  if (layer == null) return css;

  const importStatements = FindImportStatements(css).map(
    (s) => `${s} layer(${layer});`
  );
  css = css.replace(IMPORT_STATEMENT_REGEX, '');
  if (removeImportant) css = css.replaceAll('!important', '');

  return `${importStatements.join('\n')}\n@layer ${layer} {\n${css}\n}`;
}
